/*
 * @Author: wuziyang 764401855@qq.com
 * @Date: 2022-09-14 10:34:58
 * @LastEditors: 吴紫阳 764401855@qq.com
 * @LastEditTime: 2022-10-10 16:16:38
 * @FilePath: \tsdx-template\src\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
// import OtherName from './lib/button/OtherName'
import PitBimwinApp from './PitBimwinApp';
import PitBimWinDialog from './components/PitBimwinDialog/PitBimwinDialog';
import PitBimWinMessage from './components/PitBimWinMessage';
import './styles/index.scss';
import './styles/label.scss';
import './styles/switchCheckBox.scss';
import './styles/information.scss';
import './styles/setUp.scss';
import './assets/styles/pit-bimwin-ui.scss';
// 远程字体
const link = document.createElement('link');
link.href = 'https://at.alicdn.com/t/c/font_3662346_ghnhbk6buza.css';
link.rel = 'stylesheet';
link.type = 'text/css';
document.head.appendChild(link);
export { PitBimwinApp, PitBimWinDialog, PitBimWinMessage };
